export default "__VITE_ASSET__957c7c34__"